import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=53f486ad&scoped=true&"
import script from "./Recruit.vue?vue&type=script&lang=js&"
export * from "./Recruit.vue?vue&type=script&lang=js&"
import style0 from "./Recruit.vue?vue&type=style&index=0&id=53f486ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f486ad",
  null
  
)

export default component.exports